const RedirectToHelpAndSupport = () => {
  window.location.href = 'https://www.xfinity.com/support/articles/returning-your-equipment';
  return false;
};

export default RedirectToHelpAndSupport;
